import React, { MouseEventHandler } from "react";

import InfoModalContainer from "../Container";
import ConfirmationBox from "@components/cards/messageBox/ConfirmationBox";
import Button from '@components/buttons/Button/Button';


interface IConfirmation {
    message: string
    additionalInfo?: string
    onClickClose: MouseEventHandler
};


export default function Confirmation({ message, additionalInfo, onClickClose }: IConfirmation) {
    return (
        <InfoModalContainer>
            <ConfirmationBox message={message} />
            {additionalInfo}
            <Button label='Ok' onClickFunc={onClickClose} />
        </InfoModalContainer>
    );
};
